import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { SiteUser, UserLogo } from '../../../model/user';
import { HttpService } from '../httpService/http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpUserService extends UserService {
  private readonly apiUrl = '/api/users';

  constructor(
    private httpService: HttpService
  ) {
    super();
  }

  getUsers(): Observable<SiteUser[]> {
    return this.httpService.get('/getUsers', true)
  }

  getUserLogos(): Observable<UserLogo[]> {
    return this.httpService.get('/getUserLogos', true);
  }

  saveUserLogo(userId: number, logoId: number): Observable<void> {
    return this.httpService.post(`/saveUserLogo?userId=${userId}&logoId=${logoId}`, null, true);
  }
}
